import { useTranslation } from "react-i18next";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20products%20arranged%20on%20warm%20neutral%20background%20soft%20natural%20light%20minimal%20clean%20aesthetic%20editorial%20photography%20high%20detail&width=1600&height=700&seq=final-cta-bg-01&orientation=landscape"
          alt="Fashion products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4 max-w-3xl mx-auto">
          {t("finalCta.h2")}
        </h2>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t("finalCta.copy")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/20 whitespace-nowrap"
          >
            {t("finalCta.ctaPrimary")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 rounded-lg bg-background-50/10 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            {t("finalCta.ctaSecondary")}
          </a>
        </div>
      </div>
    </section>
  );
}